export default __webpack_public_path__ + "static/media/scania_lock-up_v_pos_M_rgb.361720ee.png";